import React from 'react'
import { content } from '../../../config'

const { LOGO_HOME } = content

const logo = require(`../../../assets/images/${LOGO_HOME}`)

const Logotipo = ({ className }) => (
	<img
		className={`logotipo ${className}`}
		src={logo}
		alt="Logotipo Muviflex"
		style={{ background: 'transparent' }}
	/>
)

export default Logotipo
